import type { RouteObject } from "react-router-dom";
import Layout from "../modules/Layout";
import AllProjects from "../pages/AllProjects";
import DocumentPage from "../pages/Document";
import DocumentVersions from "../pages/DocumentVersions";
import Homepage from "../pages/Homepage";
import Dash from "../pages/Dash";
import MyPrecedentFiles from "../pages/MyPrecedentFiles";
import HelpSupport from "../pages/HelpSupport";
import OutlookImport from "../pages/OutlookImport";
import { PageNotFound } from "../pages/PageNotFound";
const PublicRoutes: RouteObject = {
  path: "/",
  element: <Layout />,
  children: [
    {
      path: "home",
      element: <Homepage />,
    },
    {
      // DEX-648: dashboard reachable only by direct URL (not linked from nav).
      // As a Layout child it inherits the header + Layout auth gate automatically.
      path: "dash",
      element: <Dash />,
    },
    {
      path: "support",
      element: <HelpSupport />,
    },
    {
      path: "home/project",
      element: <AllProjects />,
    },
    {
      path: "home/project/:projectId",
      element: <DocumentPage />,
    },
    {
      path: "home/:projectId",
      element: <DocumentPage />,
    },
    {
      path: "home/precedent",
      element: <MyPrecedentFiles />,
    },
    {
      path: "document",
      element: <DocumentPage />,
    },
    {
      path:"home/:folderName/versions",
      element:<DocumentVersions/>
    },
    {
      path:"home/project/:folderName/versions",
      element:<DocumentVersions/>
    },
    {
      path: "import",
      element: <OutlookImport />,
    },
    {
      path:"pagenotfound",
      element:<PageNotFound/>
    }
  ],
};
export default PublicRoutes;
